import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { showRightSidebarAction, toggleLeftmenu } from "store/actions";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { localTimeOfTimezone } from "common/timeConversions";
import NotificationDropdown from "components/CommonForBoth/TopbarDropdown/NotificationDropdown";
import { me, TIME_ZONE, UPDATE_CLOCK_INTERVAL } from "constants/Client";
import { ADMIN_MANAGER_APIS, IS_STAFF_ROLE, IS_SUPERADMIN_ROLE, ROLES } from "common/ComponentAccess";
import AppButton from "component/Buttons/AppButton";

const Header = props => {
  const [currentTime, setcurrentTime] = useState(localTimeOfTimezone("LT MMM DD, YY") || "");

  const logo = `${process.env.REACT_APP_APIBASE}/${me().company_logo}` || "";
  const isAccessable = !ADMIN_MANAGER_APIS();

  const getTime = () => {
    let intervalId = setInterval(() => {
      if (isAccessable) clearInterval(intervalId);
      setcurrentTime(() => localTimeOfTimezone("LT MMM DD, YY"));
    }, UPDATE_CLOCK_INTERVAL);
  };

  useEffect(() => {
    if (isAccessable) return;
    getTime();
  }, []);

  return (
    <React.Fragment>
      <header id='page-topbar'>
        <div className='navbar-header'>
          <div className='d-flex'>
            <button
              type='button'
              className='btn btn-sm px-3 font-size-16 d-lg-none header-item'
              data-toggle='collapse'
              data-target='#topnav-menu-content'
              onClick={() => {
                props.toggleLeftmenu(!props.leftMenu);
              }}>
              <i className='fa fa-fw fa-bars' />
            </button>
            {!isAccessable && (
              <div className='navbar-brand-box'>
                <Link to='/' className='logo logo-light'>
                  <span className='logo-sm'>
                    <img src={logo} alt='' className='rounded' height='55px' />
                  </span>
                  <span className='logo-lg'>
                    <img src={logo} alt='' className='rounded' height='35px' />
                  </span>
                </Link>
              </div>
            )}
            {IS_SUPERADMIN_ROLE() && <h4 className='fw-bold text-white m-0 ms-3 mt-4 mt-lg-0'>Super Admin</h4>}
          </div>

          <div className='d-flex align-items-center'>
            <div className='d-inline-block'>
              <div className='text-white'>
                {!isAccessable && (
                  <>
                    <span className='d-none d-md-block'>
                      {TIME_ZONE() || "Australia/Sydney"} <span className='d-none d-md-inline'> - {currentTime}</span>
                      {ADMIN_MANAGER_APIS() && <NotificationDropdown />}
                    </span>
                  </>
                )}

                {IS_STAFF_ROLE() && (
                  <AppButton size='md' label='Refresh' prefixIcon={<i className='mdi mdi-reload' />} onClick={() => (window.location = window.location.href)} />
                )}
              </div>
            </div>
            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
})(withTranslation()(Header));
